import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import * as ReactDOM from 'react-dom';
import { BrandProvider, useBrand } from '@shared-ui/brand-context';
import { a as EGDSIcon } from '../icon/index-chunk.esm.js';
import { a as EGDSBlockSkeleton } from '../skeleton-line/index-chunk.esm.js';
import { d as EGDSLayoutPosition } from '../layout-position/index-chunk.esm.js';
import { defaultConfig, EGMap } from '@eg-maps/core';
import * as React from 'react';
import { createContext } from 'react';
import { c as classNames } from '../theme-provider/index-chunk.esm.js';
import { i as initMapBoxApi } from '../mapbox-api/index-chunk.esm.js';
import { i as initGoogleMapsApi } from '../google-api/index-chunk.esm.js';
import '@eg-maps/google-maps';
import '@eg-maps/mapbox';
import { mergeAndConcat } from 'merge-anything';
import { EGDistances } from 'eg-distances';
import styles from '../styles/uitk-egds-map.css';
var EGDSEGMapsQualifier;
(function (EGDSEGMapsQualifier) {
  EGDSEGMapsQualifier["ACTIVITY"] = "activities__activity";
  EGDSEGMapsQualifier["AIRPORT"] = "transport__airport";
  EGDSEGMapsQualifier["BOOKED"] = "booked";
  EGDSEGMapsQualifier["BUS_STATION"] = "transport__busStation";
  EGDSEGMapsQualifier["CAR"] = "lob_cars";
  EGDSEGMapsQualifier["CONVENIENCE"] = "store__convenience";
  EGDSEGMapsQualifier["CRUISE"] = "portOfCall";
  EGDSEGMapsQualifier["FLIGHTPATH"] = "flightPath";
  EGDSEGMapsQualifier["FOCAL"] = "focal";
  EGDSEGMapsQualifier["FOOD_AND_DRINKS"] = "service__foodAndDrinks";
  EGDSEGMapsQualifier["FOOD_STORE"] = "service__foodStore";
  // @deprecated use FOOD_STORE
  EGDSEGMapsQualifier["GROCERY"] = "service__groceryStore";
  EGDSEGMapsQualifier["HIDDEN"] = "hidden";
  EGDSEGMapsQualifier["HOTEL"] = "lob_hotels";
  EGDSEGMapsQualifier["LANDMARK"] = "placeOfInterest__landmark";
  EGDSEGMapsQualifier["MEMBER_DEAL"] = "member_deal";
  EGDSEGMapsQualifier["METRO_STATION"] = "transport__metroStation";
  EGDSEGMapsQualifier["MINIPIN"] = "minipin";
  EGDSEGMapsQualifier["NOT_CLUSTERED"] = "not_clustered";
  EGDSEGMapsQualifier["OBFUSCATED"] = "obfuscate";
  EGDSEGMapsQualifier["OBFUSCATED_PIN"] = "pinObfuscate";
  EGDSEGMapsQualifier["OBFUSCATED_PRICE"] = "priceObfuscate";
  EGDSEGMapsQualifier["OVER"] = "over";
  EGDSEGMapsQualifier["PARKING"] = "service__parking";
  EGDSEGMapsQualifier["PEOPLE"] = "activities__redeemingPoint";
  EGDSEGMapsQualifier["PERSON"] = "person";
  EGDSEGMapsQualifier["PINNED"] = "pinned";
  EGDSEGMapsQualifier["POINT_OF_INTEREST"] = "tourism__placeOfInterest";
  EGDSEGMapsQualifier["RECOMMENDED"] = "recommended";
  // @deprecated use FOOD_AND_DRINKS
  EGDSEGMapsQualifier["RESTAURANT"] = "service__restaurant";
  EGDSEGMapsQualifier["SAVED"] = "saved";
  // @deprecated use METRO_STATION
  EGDSEGMapsQualifier["TRANSIT"] = "transport__metroStation";
  EGDSEGMapsQualifier["TRANSPORTATION"] = "transport__trainStation";
  EGDSEGMapsQualifier["TRAVELER"] = "traveler";
  EGDSEGMapsQualifier["VACATION_RENTAL"] = "vacation_rental";
  EGDSEGMapsQualifier["VIEWED"] = "viewed";
})(EGDSEGMapsQualifier || (EGDSEGMapsQualifier = {}));
var EGDSEGMapsEGDSIconType;
(function (EGDSEGMapsEGDSIconType) {
  EGDSEGMapsEGDSIconType["ACTIVITY"] = "lob_activities";
  EGDSEGMapsEGDSIconType["AIRPORT"] = "lob_flights";
  EGDSEGMapsEGDSIconType["BUS_STATION"] = "directions_bus";
  EGDSEGMapsEGDSIconType["CAR"] = "lob_cars";
  EGDSEGMapsEGDSIconType["CHECK_CIRCLE"] = "check_circle";
  EGDSEGMapsEGDSIconType["CONVENIENCE"] = "shopping_cart";
  EGDSEGMapsEGDSIconType["CRUISE"] = "lob_cruise";
  EGDSEGMapsEGDSIconType["FLIGHTPATH"] = "flightPath";
  EGDSEGMapsEGDSIconType["FOOD_AND_DRINKS"] = "local_dining";
  EGDSEGMapsEGDSIconType["FOOD_STORE"] = "shopping_cart";
  // @deprecated use FOOD_STORE
  EGDSEGMapsEGDSIconType["GROCERY"] = "shopping_cart";
  EGDSEGMapsEGDSIconType["HOTEL"] = "lob_hotels";
  EGDSEGMapsEGDSIconType["LANDMARK"] = "place";
  EGDSEGMapsEGDSIconType["METRO_STATION"] = "train";
  EGDSEGMapsEGDSIconType["ONEKEYCOIN"] = "onekeycoin";
  EGDSEGMapsEGDSIconType["PARKING"] = "local_parking";
  EGDSEGMapsEGDSIconType["PEOPLE"] = "people";
  EGDSEGMapsEGDSIconType["PERSON"] = "person";
  EGDSEGMapsEGDSIconType["POI"] = "circle_filled";
  // @deprecated use FOOD_AND_DRINKS
  EGDSEGMapsEGDSIconType["RESTAURANT"] = "local_dining";
  EGDSEGMapsEGDSIconType["SAVED"] = "favorite";
  EGDSEGMapsEGDSIconType["SOLD_OUT"] = "remove";
  // @deprecated use METRO_STATION
  EGDSEGMapsEGDSIconType["TRANSIT"] = "train";
  EGDSEGMapsEGDSIconType["TRANSPORTATION"] = "train";
  EGDSEGMapsEGDSIconType["VACATION_RENTAL"] = "lob_vacation_rentals";
})(EGDSEGMapsEGDSIconType || (EGDSEGMapsEGDSIconType = {}));
var EGDSEGMapsType;
(function (EGDSEGMapsType) {
  EGDSEGMapsType["MAPBOX"] = "mapbox";
  EGDSEGMapsType["GOOGLE"] = "google";
})(EGDSEGMapsType || (EGDSEGMapsType = {}));
const EGDSEGMapsContext = createContext(null);
const useIsMounted = () => {
  const isMounted = React.useRef(false);
  React.useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);
  return isMounted;
};
const EGDSEGMapsScriptLoader = ({
  width,
  height,
  mapType,
  mapTypeVersion,
  accessToken,
  children,
  locale,
  googleMapsId,
  reloadMapProviderSDK = false,
  onError
}) => {
  const isMounted = useIsMounted();
  const [loadingCount, setLoadingCount] = React.useState(1);
  const [error, setError] = React.useState();
  const egMapsConfig = defaultConfig();
  React.useEffect(() => {
    const timeoutDuration = 10000;
    const timeoutPromise = new Promise((resolve, reject) => {
      setTimeout(() => {
        reject(new Error('Timeout: Map API initialization took too long'));
      }, timeoutDuration);
    });
    switch (mapType) {
      case EGDSEGMapsType.GOOGLE:
        {
          const baseUrl = egMapsConfig.googleMaps?.urls?.api;
          if (baseUrl) {
            const conf = {
              accessToken,
              mapId: googleMapsId,
              locale,
              version: mapTypeVersion
            };
            Promise.race([initGoogleMapsApi(reloadMapProviderSDK, conf, false), timeoutPromise]).then(() => {
              if (isMounted.current) {
                setLoadingCount(0);
              }
            }).catch(err => {
              setError(err.message);
              if (typeof onError === 'function') onError(err);
            });
          } else {
            const err = {
              message: 'No base URL found in eg-maps config to load google maps sdk'
            };
            setError(err.message);
            if (typeof onError === 'function') onError(err);
          }
        }
        break;
      case EGDSEGMapsType.MAPBOX:
        {
          const conf = {
            version: mapTypeVersion
          };
          Promise.race([initMapBoxApi(reloadMapProviderSDK, conf), timeoutPromise]).then(() => {
            if (isMounted.current) {
              setLoadingCount(0);
            }
          }).catch(err => {
            setError(err.message);
            if (typeof onError === 'function') onError(err);
          });
        }
        break;
      default:
        {
          const err = {
            message: `Map provider not supported: ${mapType}`
          };
          setError(err.message);
          if (typeof onError === 'function') onError(err);
        }
    }
  }, []);
  if (loadingCount > 0 && !error) {
    return jsx("div", {
      style: {
        width,
        height
      },
      children: jsx(EGDSLayoutPosition, {
        type: "relative",
        position: {
          top: 'center',
          left: 'center'
        },
        children: jsx("div", {
          style: {
            width,
            height,
            position: 'relative'
          },
          children: jsx(EGDSBlockSkeleton, {})
        })
      })
    });
  }
  return jsx(Fragment, {
    children: children
  });
};

/*
  This is a HOC that loads the google/mapbox JS api before rendering the child component that is passed as a parameter.
*/
const withScriptLoader = (childComponent, props) => {
  const scriptLoaderProps = {
    accessToken: props.accessToken,
    googleMapsId: props.mapConfig?.googleMapsId,
    locale: props.mapConfig?.locale,
    mapType: props.mapType,
    mapTypeVersion: props.mapTypeVersion,
    width: props.width,
    height: props.height,
    reloadMapProviderSDK: props.reloadMapProviderSDK,
    onError: props.onError
  };
  return jsx(EGDSEGMapsScriptLoader, {
    ...scriptLoaderProps,
    children: childComponent
  });
};
/*
  This function takes icon name and brand as a parameter and renders the svg into a div
*/
const buildIcon = (iconName, className, brand) => {
  const icon = jsx(BrandProvider, {
    config: brand,
    children: jsx(EGDSIcon, {
      name: iconName,
      className: `${className} ${iconName}`
    })
  });
  const container = document.createElement('div');
  ReactDOM.render(icon, container);
  return container;
};
const buildMinipin = () => {
  const miniPinSvg = jsx("svg", {
    width: "18",
    height: "12",
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: jsxs("g", {
      children: [jsx("rect", {
        x: "0",
        y: "0",
        width: "18",
        height: "12",
        rx: "6",
        fill: "white"
      }), jsx("rect", {
        x: "0.5",
        y: "0.5",
        width: "17",
        height: "11",
        rx: "5.5",
        stroke: "#676A7C"
      })]
    })
  });
  const container = document.createElement('div');
  ReactDOM.render(miniPinSvg, container);
  return container;
};
const extractRGBA = color => {
  if (color) {
    if (color.startsWith('#')) return {
      rgb: color,
      alpha: 1.0
    };
    if (color.startsWith('rgb(')) return {
      rgb: color,
      alpha: 1.0
    };
    if (color.startsWith('rgba(')) {
      const [, rgb, alpha] = /rgba\(([0-9, ]*),[ ]*([0-9.]*)[ ]*\)/.exec(color) || [];
      if (rgb) return {
        rgb: `rgb(${rgb})`,
        alpha: parseFloat(alpha)
      };
    }
  }
  return {
    rgb: color || 'rgb(0, 0, 0)',
    alpha: 1.0
  };
};
const primaryIconClass = 'uitk-eg-maps-primary-icon';
const secondaryIconClass = 'uitk-eg-maps-secondary-icon';
const DEFAULT_FONT_SIZE = '16px';
const convertRemToPixels = rem => parseFloat(rem) * parseFloat(getComputedStyle(document.documentElement)?.fontSize || DEFAULT_FONT_SIZE);
const defaultEGMapsConfig = (brand, getCssValue) => {
  const routeColor = extractRGBA(getCssValue('--uitk-map__route__border_color')?.trim());
  const routeBorder = getCssValue('--uitk-map__route__border_width')?.trim();
  const routeBorderPixels = routeBorder?.includes('rem') ? convertRemToPixels(routeBorder) : routeBorder;
  const routeSize = typeof routeBorderPixels === 'string' ? parseInt(routeBorderPixels, 10) : routeBorderPixels;
  const obfuscateAreaFillColor = extractRGBA(getCssValue('--uitk-map__obfuscate_fill_color')?.trim());
  const obfuscateAreaLineColor = extractRGBA(getCssValue('--uitk-map__obfuscate_line_color')?.trim());
  const obfuscateAreaLineWeight = parseInt(getCssValue('background-position-x') || '1', 10);
  const soldOutIcon = buildIcon(EGDSEGMapsEGDSIconType.SOLD_OUT, primaryIconClass, brand);
  const product = {
    show: {
      available: true,
      sold_out: true,
      unknown: true,
      minipin: true
    },
    markerType: {
      sold_out: 'pin',
      available: 'price',
      booking: 'pin',
      [EGDSEGMapsQualifier.OBFUSCATED]: 'obfuscate',
      [EGDSEGMapsQualifier.OBFUSCATED_PIN]: 'pinObfuscate',
      [EGDSEGMapsQualifier.OBFUSCATED_PRICE]: 'priceObfuscate',
      [EGDSEGMapsQualifier.MINIPIN]: 'pin',
      [`${EGDSEGMapsQualifier.MINIPIN}#${EGDSEGMapsQualifier.OVER}`]: 'price',
      [`${EGDSEGMapsQualifier.MINIPIN}#hl`]: 'price'
    },
    actionOnMouseOver: {
      [EGDSEGMapsQualifier.MINIPIN]: ['sendEvent']
    },
    actionOnMouseOut: {
      [EGDSEGMapsQualifier.MINIPIN]: ['sendEvent']
    },
    icons: {
      hl: null,
      available: null,
      default: buildIcon(EGDSEGMapsEGDSIconType.HOTEL, primaryIconClass, brand),
      [`${EGDSEGMapsQualifier.HOTEL}#sold_out`]: soldOutIcon,
      [`${EGDSEGMapsQualifier.CAR}#sold_out`]: soldOutIcon,
      [`${EGDSEGMapsQualifier.VACATION_RENTAL}#sold_out`]: soldOutIcon,
      [`${EGDSEGMapsQualifier.OBFUSCATED_PIN}#sold_out`]: soldOutIcon,
      [`${EGDSEGMapsQualifier.AIRPORT}#sold_out`]: soldOutIcon,
      [`${EGDSEGMapsQualifier.ACTIVITY}#sold_out`]: soldOutIcon,
      [`${EGDSEGMapsQualifier.CRUISE}#sold_out`]: soldOutIcon,
      sold_out: soldOutIcon,
      [EGDSEGMapsQualifier.HOTEL]: buildIcon(EGDSEGMapsEGDSIconType.HOTEL, primaryIconClass, brand),
      [EGDSEGMapsQualifier.CAR]: buildIcon(EGDSEGMapsEGDSIconType.CAR, primaryIconClass, brand),
      [EGDSEGMapsQualifier.VACATION_RENTAL]: buildIcon(EGDSEGMapsEGDSIconType.VACATION_RENTAL, primaryIconClass, brand),
      [EGDSEGMapsQualifier.AIRPORT]: buildIcon(EGDSEGMapsEGDSIconType.AIRPORT, primaryIconClass, brand),
      [EGDSEGMapsQualifier.ACTIVITY]: buildIcon(EGDSEGMapsEGDSIconType.ACTIVITY, primaryIconClass, brand),
      [EGDSEGMapsQualifier.CRUISE]: buildIcon(EGDSEGMapsEGDSIconType.CRUISE, primaryIconClass, brand),
      [EGDSEGMapsQualifier.MINIPIN]: buildMinipin(),
      [`available#${EGDSEGMapsQualifier.MINIPIN}`]: buildMinipin()
    },
    frameIcons: {
      default: 'pin',
      [EGDSEGMapsQualifier.OBFUSCATED_PIN]: 'circle',
      [EGDSEGMapsQualifier.MINIPIN]: 'none'
    },
    zIndex: {
      default: 10,
      hl: 20,
      available: 12,
      filtered: 11,
      sold_out: 10,
      unknown: null,
      [`available#${EGDSEGMapsQualifier.MINIPIN}`]: 10,
      [`available#${EGDSEGMapsQualifier.MINIPIN}#${EGDSEGMapsQualifier.OVER}`]: 20,
      [`available#${EGDSEGMapsQualifier.MINIPIN}#hl`]: 20
    },
    cornerIcons: {
      topRight: {
        [EGDSEGMapsQualifier.SAVED]: buildIcon(EGDSEGMapsEGDSIconType.SAVED, secondaryIconClass, brand)
      }
    },
    innerIcons: {
      left: {
        [EGDSEGMapsQualifier.MEMBER_DEAL]: buildIcon(EGDSEGMapsEGDSIconType.ONEKEYCOIN, primaryIconClass, brand)
      },
      right: {
        [EGDSEGMapsQualifier.BOOKED]: buildIcon(EGDSEGMapsEGDSIconType.CHECK_CIRCLE, primaryIconClass, brand)
      }
    },
    minZoomForDisplay: {
      default: -1
    },
    clustering: {
      default: {
        type: 'supercluster',
        excludedQualifiers: [EGDSEGMapsQualifier.NOT_CLUSTERED],
        superclusterSettings: {
          radius: 105
        },
        maxZoom: 15,
        minPoints: 10
      }
    },
    obfuscateMarkers: {
      radiusInM: {
        default: 1000
      },
      style: {
        default: {
          line: {
            weight: obfuscateAreaLineWeight,
            color: obfuscateAreaLineColor?.rgb,
            opacity: obfuscateAreaLineColor?.alpha
          },
          fill: {
            color: obfuscateAreaFillColor?.rgb,
            opacity: obfuscateAreaFillColor?.alpha
          }
        },
        hl: {
          line: {
            weight: obfuscateAreaLineWeight,
            color: obfuscateAreaLineColor?.rgb,
            opacity: obfuscateAreaLineColor?.alpha
          },
          fill: {
            color: obfuscateAreaFillColor?.rgb,
            opacity: obfuscateAreaFillColor?.alpha
          }
        }
      }
    }
  };
  const mapConfig = {
    markers: {
      product,
      property: product,
      place: {
        show: {
          default: true,
          unknown: true
        },
        markerType: {
          default: 'pin'
        },
        minZoomForDisplay: {
          default: -1
        },
        threshold: {
          default: 1000
        },
        icons: {
          default: buildIcon(EGDSEGMapsEGDSIconType.POI, primaryIconClass, brand),
          unknown: null,
          hl: null,
          [EGDSEGMapsQualifier.AIRPORT]: buildIcon(EGDSEGMapsEGDSIconType.AIRPORT, primaryIconClass, brand),
          [EGDSEGMapsQualifier.RESTAURANT]: buildIcon(EGDSEGMapsEGDSIconType.RESTAURANT, primaryIconClass, brand),
          [`${EGDSEGMapsQualifier.RESTAURANT}#${EGDSEGMapsQualifier.GROCERY}`]: buildIcon(EGDSEGMapsEGDSIconType.RESTAURANT, primaryIconClass, brand),
          [EGDSEGMapsQualifier.FOOD_AND_DRINKS]: buildIcon(EGDSEGMapsEGDSIconType.FOOD_AND_DRINKS, primaryIconClass, brand),
          [EGDSEGMapsQualifier.CAR]: buildIcon(EGDSEGMapsEGDSIconType.CAR, primaryIconClass, brand),
          [EGDSEGMapsQualifier.GROCERY]: buildIcon(EGDSEGMapsEGDSIconType.GROCERY, primaryIconClass, brand),
          [EGDSEGMapsQualifier.FOOD_STORE]: buildIcon(EGDSEGMapsEGDSIconType.FOOD_STORE, primaryIconClass, brand),
          [EGDSEGMapsQualifier.CONVENIENCE]: buildIcon(EGDSEGMapsEGDSIconType.CONVENIENCE, primaryIconClass, brand),
          [EGDSEGMapsQualifier.TRANSPORTATION]: buildIcon(EGDSEGMapsEGDSIconType.TRANSPORTATION, primaryIconClass, brand),
          [EGDSEGMapsQualifier.METRO_STATION]: buildIcon(EGDSEGMapsEGDSIconType.METRO_STATION, primaryIconClass, brand),
          [EGDSEGMapsQualifier.BUS_STATION]: buildIcon(EGDSEGMapsEGDSIconType.BUS_STATION, primaryIconClass, brand),
          [EGDSEGMapsQualifier.PARKING]: buildIcon(EGDSEGMapsEGDSIconType.PARKING, primaryIconClass, brand),
          [EGDSEGMapsQualifier.PEOPLE]: buildIcon(EGDSEGMapsEGDSIconType.PEOPLE, primaryIconClass, brand),
          [EGDSEGMapsQualifier.PERSON]: buildIcon(EGDSEGMapsEGDSIconType.PERSON, primaryIconClass, brand),
          [EGDSEGMapsQualifier.ACTIVITY]: buildIcon(EGDSEGMapsEGDSIconType.ACTIVITY, primaryIconClass, brand)
        },
        frameIcons: {
          default: 'pin',
          [EGDSEGMapsQualifier.OBFUSCATED_PIN]: 'circle'
        },
        zIndex: {
          default: 1,
          unknown: null,
          hl: 20,
          [EGDSEGMapsQualifier.AIRPORT]: 3,
          [EGDSEGMapsQualifier.METRO_STATION]: 3,
          [EGDSEGMapsQualifier.BUS_STATION]: 3,
          [EGDSEGMapsQualifier.TRANSPORTATION]: 3,
          [EGDSEGMapsQualifier.LANDMARK]: 3,
          [EGDSEGMapsQualifier.POINT_OF_INTEREST]: 3
        },
        cornerIcons: {
          topRight: {
            [EGDSEGMapsQualifier.SAVED]: buildIcon(EGDSEGMapsEGDSIconType.SAVED, secondaryIconClass, brand)
          }
        }
      },
      cluster: {
        zIndex: {
          default: 9,
          hl: 20
        }
      }
    },
    routes: {
      style: {
        driving: {
          lineStyle: 'normal',
          color: routeColor.rgb,
          width: routeSize,
          opacity: routeColor.alpha
        },
        cycling: {
          lineStyle: 'normal',
          color: routeColor.rgb,
          width: routeSize,
          opacity: routeColor.alpha
        },
        walking: {
          lineStyle: 'normal',
          color: routeColor.rgb,
          width: routeSize,
          opacity: routeColor.alpha
        },
        flying: {
          color: routeColor.rgb,
          opacity: routeColor.alpha
        }
      }
    }
  };
  return mapConfig;
};
const getCircularReplacer = () => {
  const seen = new WeakSet();
  return (key, value) => {
    if (typeof value === 'object' && value !== null) {
      if (seen.has(value)) {
        return;
      }
      seen.add(value);
    }
    return value;
  };
};
const isAnHtmlElement = comp => {
  if (comp) return comp.nodeName !== undefined;
  return false;
};
const isObject = elt => elt !== null && typeof elt === 'object' && !isAnHtmlElement(elt) && Object.prototype.toString.call(elt) !== '[object Array]';
/**
 * Sort all arrays deeply in object
 *
 * @param {any} obj
 * @returns {any}
 */
const sortDeeplyObjectAndArray = obj => {
  if (obj) {
    if (Array.isArray(obj)) return obj.sort();
    if (isObject(obj)) {
      if (obj.constructor?.name === 'Object') {
        const ret = {};
        Object.keys(obj).sort().forEach(k => {
          ret[k] = sortDeeplyObjectAndArray(obj[k]);
        });
        return ret;
      }
      return obj;
    }
    return obj;
  }
  return obj;
};
/**
 * Stringify an object
 *
 * @param {any} elt
 * @returns {String}
 */
const stringify = elt => JSON.stringify(elt, getCircularReplacer());
const getClassNameList = classNames.bind(styles);
const defaultMapboxStyle = 'mapbox://styles/mapbox/streets-v11';
const gmapCfg = () => ({
  mapProvider: 'google-maps',
  googleMaps: {
    gmapsAddConfig: {
      streetViewControl: true,
      streetViewControlOptions: {
        position: window?.google?.maps?.ControlPosition.RIGHT_TOP
      },
      zoomControlOptions: {
        position: window?.google?.maps?.ControlPosition.RIGHT_TOP
      },
      scaleControl: true
    }
  }
});
const mapboxCfg = accessToken => ({
  mapProvider: 'mapbox',
  mapbox: {
    accessToken,
    mapboxAddConf: {
      style: defaultMapboxStyle
    }
  }
});
const egDistancesConfig = (provider, accessToken) => ({
  routes: {
    egDistances: provider === 'mapbox' ? new EGDistances({
      provider: EGDistances.providers.mapbox,
      providers: {
        [EGDistances.providers.mapbox]: {
          key: accessToken
        }
      }
    }) : new EGDistances({
      provider: EGDistances.providers.google
    })
  }
});
const EGDSEGMapsContainer = ({
  height = '100%',
  width = '100%',
  egDistancesEnabled = false,
  initialViewport,
  accessToken,
  children,
  mapType,
  features,
  onFeaturesPushed,
  mapConfig = {},
  className,
  innerRef,
  beforeInit,
  onInit,
  clientPadding,
  onError
}) => {
  const mapProvider = mapType === EGDSEGMapsType.GOOGLE ? 'google-maps' : 'mapbox';
  const [mapContext, setMapContext] = React.useState();
  const [initialConfig, setInitialConfig] = React.useState();
  const [providedConfig, setProvidedConfig] = React.useState();
  const mapMemoValue = React.useMemo(() => ({
    mapContext,
    setMapContext
  }), [mapContext, setMapContext]);
  const mapRef = React.useRef();
  const brand = useBrand();
  const idSuffix = React.useMemo(() => Math.floor(Math.random() * 90), []);
  React.useImperativeHandle(innerRef, () => ({
    map: () => mapContext?.mapObj || null
  }));
  const baseConfig = React.useMemo(() => {
    let ret;
    if (mapRef.current) {
      const egDistancesCfg = egDistancesEnabled ? egDistancesConfig(mapProvider, accessToken) : {};
      const mapProviderCfg = mapProvider === 'mapbox' ? mapboxCfg(accessToken) : gmapCfg();
      const defaultCfg = defaultEGMapsConfig(brand, cssPropertyName => getComputedStyle(mapRef.current)?.getPropertyValue(cssPropertyName));
      ret = mergeAndConcat(defaultCfg, mapProviderCfg, egDistancesCfg);
    }
    return ret;
  }, [mapRef.current, brand, mapProvider, accessToken, egDistancesEnabled]);
  React.useEffect(() => {
    if (mapConfig) {
      const cfg = mapConfig ? sortDeeplyObjectAndArray(mapConfig) : {};
      if (providedConfig === undefined || stringify(cfg) !== stringify(providedConfig)) {
        setProvidedConfig(cfg);
      }
    }
  }, [mapConfig, providedConfig]);
  const config = React.useMemo(() => {
    let ret;
    if (baseConfig) {
      const configs = [];
      if (providedConfig) {
        configs.push(providedConfig);
        if (providedConfig.googleMaps?.gmapsAddConfig?.mapId === null) configs.push({
          googleMaps: {
            gmapsAddConfig: {
              mapId: undefined
            }
          }
        });
        if (providedConfig.mapbox?.mapboxAddConf?.style === null) configs.push({
          mapbox: {
            mapboxAddConf: {
              style: undefined
            }
          }
        });
      }
      ret = mergeAndConcat(baseConfig, ...configs);
    }
    return ret;
  }, [baseConfig, providedConfig]);
  React.useEffect(() => {
    const {
      mapObj
    } = mapContext || {};
    if (config && config !== initialConfig) {
      if (mapObj) {
        mapObj.updateConfiguration(config);
      } else if (!initialConfig) {
        setInitialConfig(config);
      }
    }
  }, [initialConfig, config, mapContext]);
  React.useEffect(() => {
    if (initialConfig) {
      if (mapContext?.mapObj) {
        mapContext?.mapObj.unbindAll();
      }
      try {
        const mapObj = new EGMap(initialConfig);
        if (beforeInit) beforeInit(mapObj);
        mapObj.initMap(mapRef.current, true, initialViewport, clientPadding).then(() => {
          if (onInit) onInit(mapObj);
          setMapContext({
            mapObj,
            mapConfig: initialConfig
          });
        }).catch(err => {
          if (typeof onError === 'function') onError(err);
        });
      } catch (err) {
        if (typeof onError === 'function') onError(err);
      }
      return () => {
        mapContext?.mapObj?.unbindAll();
      };
    }
  }, [initialConfig]);
  React.useEffect(() => {
    if (mapContext?.mapObj && features) {
      const bounds = mapContext?.mapObj.pushFeatureData(features, 'replace');
      if (bounds) onFeaturesPushed?.(mapContext?.mapObj, bounds);
    }
  }, [mapContext, features, onFeaturesPushed]);
  return jsx("div", {
    className: getClassNameList('uitk-eg-maps-container', 'uitk-eg-maps', className),
    style: {
      width,
      height
    },
    id: `uitk-eg-maps-container-${idSuffix}`,
    ref: mapRef,
    children: mapContext?.mapObj && jsx(EGDSEGMapsContext.Provider, {
      value: mapMemoValue,
      children: children
    })
  });
};

/**
 * The EGDSMap component is going to be deprecated in favor of the Map component in the maps workspace.
 * Please update your imports and usage to use the new Map component from the maps workspace (@egds/react-maps).
 *
 * Business-level eg-maps component.
 */
const EGDSEGMaps = ({
  children,
  ...rest
}) => {
  console.warn('The EGDSEGMaps component is deprecated. Please use the component from the maps workspace instead.');
  return withScriptLoader(jsx(EGDSEGMapsContainer, {
    ...rest,
    children: children
  }), {
    ...rest
  });
};
const defaultProps = {
  clustering: false,
  height: '100%',
  mapStyle: 'mapbox://styles/mapbox/streets-v10',
  mapType: EGDSEGMapsType.GOOGLE,
  markerType: 'price',
  showPopup: false,
  width: '100%'
};
EGDSEGMaps.defaultProps = defaultProps;
export { EGDSEGMapsContainer as E, stringify as a, buildIcon as b, defaultMapboxStyle as c, defaultEGMapsConfig as d, extractRGBA as e, EGDSEGMapsScriptLoader as f, EGDSEGMaps as g, EGDSEGMapsQualifier as h, EGDSEGMapsEGDSIconType as i, EGDSEGMapsType as j, EGDSEGMapsContext as k, sortDeeplyObjectAndArray as s, useIsMounted as u, withScriptLoader as w };